import {
  Box,
  Heading,
  Text,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  Button,
  useToast,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';

export default function DeleteAccountPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [appName, setAppName] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!appName || !name || !email || !phone) {
      toast({
        title: 'Error',
        description: 'Please fill in all required fields.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    
    setIsSubmitting(true);
    // Simulate API request submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      toast({
        title: 'Request Submitted',
        description: 'Your account deletion request has been submitted successfully.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    }, 1500);
  };

  return (
    <Box minH="70vh" py={[10, 20]}>
      <VStack spacing={8} align="stretch" maxW="600px" mx="auto" px={5}>
        <Heading color="#0C727E" size="xl" textAlign="center">
          Account Deletion Request
        </Heading>
        
        <Text fontSize="md" color="gray.600" textAlign="center">
          Delete your <strong>D Labs (Customer App)</strong> or <strong>D Labs Rider (Partner App)</strong> account and associated data. 
          Both applications are operated by <strong>D Labs Healthcare Pvt Ltd (Dilate Labs)</strong>.
        </Text>

        {isSubmitted ? (
          <Alert
            status="success"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            borderRadius="md"
            p={8}
          >
            <AlertIcon boxSize="40px" mr={0} />
            <AlertTitle mt={4} mb={1} fontSize="lg">
              Request Received
            </AlertTitle>
            <AlertDescription maxWidth="sm">
              Your account and data deletion request for <strong>{name}</strong> has been logged. 
              We will permanently delete your account, login credentials, location logs, and all other sensitive user data from our databases within 30 days. 
              A confirmation email will be sent to <strong>{email}</strong> once the deletion is complete.
            </AlertDescription>
          </Alert>
        ) : (
          <VStack
            as="form"
            onSubmit={handleSubmit}
            spacing={4}
            bg="white"
            p={[6, 8]}
            borderRadius="md"
            border="1px solid"
            borderColor="gray.200"
            boxShadow="sm"
            align="stretch"
          >
            <Text fontSize="sm" color="gray.600" mb={2}>
              If you currently have the mobile application installed, you can delete your account instantly by going to <strong>Profile &gt; Delete Account</strong>. Otherwise, please use the form below to request deletion:
            </Text>

            <FormControl isRequired>
              <FormLabel>Application</FormLabel>
              <Select
                placeholder="Select the application"
                value={appName}
                onChange={(e) => setAppName(e.target.value)}
              >
                <option value="D Labs (Customer App)">D Labs (Customer App)</option>
                <option value="D Labs Rider (Partner App)">D Labs Rider (Partner App)</option>
              </Select>
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Full Name</FormLabel>
              <Input
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Registered Email Address</FormLabel>
              <Input
                type="email"
                placeholder="Enter registered email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Registered Mobile Number</FormLabel>
              <Input
                placeholder="Enter registered mobile number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Reason for Deletion (Optional)</FormLabel>
              <Textarea
                placeholder="Please tell us why you are deleting your account"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </FormControl>

            <Button
              mt={4}
              bg="#0C727E"
              color="white"
              _hover={{ bg: 'teal.600' }}
              isLoading={isSubmitting}
              type="submit"
              size="lg"
            >
              Submit Deletion Request
            </Button>
          </VStack>
        )}
      </VStack>
    </Box>
  );
}
